// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import staffTrainingReducer from '../features/staffTraining/staffTrainingSlice';
import deliveriesReducer from '../features/deliveries/deliverySlice';
import checksReducer from '../features/checks/checksSlice';
import equipmentReducer from '../features/equipment/equipmentSlice';
import pestControlReducer from '../features/pestControl/pestControlSlice';
import rotaReducer from '../features/rota/rotaSlice';
import rotaScheduleReducer from '../features/rota/rotaScheduleSlice';
import usersReducer from '../features/users/usersSlice';
import departmentsReducer from '../features/departments/departmentSlice';
import jobTitlesReducer from '../features/jobTitles/jobTitleSlice';
import authReducer from '../features/auth/authSlice';
import incidentReducer from '../features/incidents/incidentSlice';
import passwordResetReducer from '../features/auth/passwordResetSlice';
import complianceCentreReducer from '../features/complianceCentre/complianceCentreSlice';

export const store = configureStore({
  reducer: {
    staffTraining: staffTrainingReducer,
    checks: checksReducer,
    deliveries: deliveriesReducer,
    equipment: equipmentReducer,
    pestControl: pestControlReducer,
    rota: rotaReducer,
    rotaSchedule: rotaScheduleReducer,
    users: usersReducer,
    departments: departmentsReducer,
    jobTitles: jobTitlesReducer,
    auth: authReducer,
    passwordReset: passwordResetReducer,
    incidents: incidentReducer,
    complianceCentre: complianceCentreReducer,
  },
});
